import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AcessoGovBrBronzeComponent } from './acesso-gov-br-bronze.component';
import { AcessoGovBrBronzeRouterService } from './acesso-gov-br.bronze.routing.service';

const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild([
    { path: 'acesso-gov-br-bronze', component: AcessoGovBrBronzeComponent }
]);

@NgModule({
    imports: [routing],
    exports: [RouterModule],
    providers: [AcessoGovBrBronzeRouterService]
})
export class AcessoGovBrBronzeRoutingModule { }
